import { render, staticRenderFns } from "./HistorialDerivacionesInterconsultas.vue?vue&type=template&id=77ebdb2a"
import script from "./HistorialDerivacionesInterconsultas.vue?vue&type=script&lang=js"
export * from "./HistorialDerivacionesInterconsultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports